import styled from 'styled-components';

const commonScreenStyle = `
  font-size: 1.5em;
  text-align: center;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;`;

export const StyledTitle = styled.h1`
   ${commonScreenStyle}
  padding: 1em;
  font-weight: bold;
  font-size: 25px;
  background-color: #fff;
  color: black;
`;

export const StyledSubtitle = styled.h2`
  ${commonScreenStyle}
  color: red;
`;

export const StyledText = styled.p`
  text-align: center;
  line-height: none;
`;

export const StyledDiv = styled.div`
  margin: 24px 50px;
`;
